<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2"> Selecione um Plano Semanal </v-card-title>

        <v-select
          :items="$constants.mesesPlanoSemanal"
          item-text="descricao"
          item-value="id"
          v-model="mes"
          return-object
          label="Selecione um mês"
          solo
        ></v-select>
        <v-select
          :items="$constants.semanas"
          item-text="descricao"
          item-value="id"
          v-model="semana"
          return-object
          label="Selecione uma semana"
          solo
        ></v-select>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :dialog="dialog"
            @status="dialog = $event"
            color="blue darken-1"
            text
            @click="cancelar()"
            >Cancelar</v-btn
          >
          <v-btn
            color="blue darken-1"
            text
            :disabled="!mes"
            @click="gerarPlanoSemanal(gestaoDeAulasId, mes?.id, semana.id, disciplinaId)"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    gestaoDeAulasId: {
      type: Number,
    },
    disciplinaId: {
      type: Number,
    },
    dialog: {
      type: Boolean,
      required: true,
    },
    typeModel: {
      type: String,
    },
  },

  watch: {
    dialog(val) {
      this.$emit("status", val);
    },
    typeModel(val) {
      this.type = val;
    },
  },
  data() {
    return {
      type: null,
      mes: null,
      semana_id: null, // Adicionando a variável semana_id
    };
  },
  methods: {
    async gerarPlanoSemanal(gestaoDeAulasId, mes, semanaId, disciplinaId) {
      try {
        this.$loaderService.open("Gerando plano semanal...");

        await this.$services.relatoriosService.planoSemanal(
          parseInt(gestaoDeAulasId, 10),
          parseInt(mes, 10),
          parseInt(semanaId, 10),
          parseInt(disciplinaId, 10)
        );
        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
      }
    },
    cancelar() {
      this.disciplinaSelecionada = null;
      this.mes = null;
      this.$emit("status", false);
    },
  },
};
</script>
